import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcessProtect } from 'src/app/model/quote/excessprotect/excessprotect.model';
import { ExcessProtectService } from '../excess.service';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteService } from '../../quote.service';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-excess-protect-quotation',
  templateUrl: './excess-protect-quotation.component.html',
  styleUrls: ['./excess-protect-quotation.component.css', '../../quote.component.css']
})
export class ExcessProtectQuotationComponent implements OnInit, OnChanges, AfterViewChecked {

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private excessProtectService: ExcessProtectService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private quoteService: QuoteService,
    private sessionSt: LocalStorageService,
    private _snackBar: MatSnackBar) {
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formFields.controls;
  }

  formFields: any;
  submitted = false;

  helptext = '';

  parentModelObject: { [p: string]: any };
  coverPeriod: string;
  reference: any;
  proposerType: string;
  isReferred = false;
  buttonText: string;
  attentionRequiredText: string;
  documents: any = [];


  quote_type: number = this.route.snapshot.params.quote_type;
  @Input() authDetails: any;
  @Input() staticData: any;
  @Input() excessProtectOptions: any;
  @Input() selectedIndex: number;
  @Input() modelObject;
  @Input() apiModelObject: {
    type: number;
    sequence_number: any;
    quote_ref_number: any;
    company_id: any;
    financial_details: { broker_admin_fee: any; };
    policy_start_date: any;
    excess_protect_cover_id: any;
    id: any;
  };
  @Output() modelObjectUpdated = new EventEmitter<ExcessProtect>();
  @Output() mtaFinancialsUpdated = new EventEmitter<any>();
  @Output() back = new EventEmitter<void>();

  // Currently selected cover ID
  selectedCoverId: string = '';

  // The currently selected premium object (will be used in template)
  selectedPremium: any = null;
  // isBroker = this.sessionSt.retrieve("is_broker");
  referAndExit = false;

  ipt = 0;
  gross = 0; // Principal Amount
  totalPremIncIpt = 0; // Principal Amount
  totalAmount = 0;
  vehiclePremiumsKey = '';
  vehiclePremiumsValue = 0;
  grossPremium = 0;
  premiums: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';
  breakdownPremiumsArr = [];
  calErrors: any = [];
  hasErrors = false;
  peliwica_fee: number;

  isAdmin = false;
  isStaff = false;
  isBroker = false;

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }

    this.formFields = this.formBuilder.group({
      breakdown_cover: [''],
      registered_owner: [''],
      commission: ['20', Validators.required],
      broker_admin_fee: ['0', Validators.required],
      discount: ['0', Validators.required],
      refer_reason: ['', Validators.required],
      excess_protect_cover_id: ['', Validators.required]
    });
    this.handleCoverDropdownState();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.apiModelObject) {
      this.modelObject = this.mapApiToExcessProtect(this.apiModelObject);
      this.modelObject.type = this.apiModelObject.type;
      this.modelObject.sequenceNumber = this.apiModelObject.sequence_number;
      this.modelObject.company_id = this.apiModelObject.company_id;
      this.modelObject.brokerAdminFee = this.apiModelObject.financial_details.broker_admin_fee;
      this.selectedCoverId = this.modelObject.excess_protect_cover_id;
      this.reference = this.apiModelObject.quote_ref_number;

      const maxDate = new Date(this.apiModelObject.policy_start_date).setFullYear(new Date(this.apiModelObject.policy_start_date).getFullYear() + 1);
      const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      this.coverPeriod = formatDate(this.apiModelObject.policy_start_date, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');
      this.getDocuments(this.apiModelObject.id);
      this.updateSelectedPremium();
      this.patchValues();

      // Load MTA financials if this is an MTA quote
      if (this.modelObject.type === 3) {
        this.fetchMTAFinancials();
      }
      
    }
    else {
      this.reference = this.modelObject.reference != null ? this.modelObject.reference : "";
      if (this.modelObject.inception_date != "") {
        const maxDate = new Date(this.modelObject.inception_date).setFullYear(new Date(this.modelObject.inception_date).getFullYear() + 1);
        const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
        this.coverPeriod = formatDate(this.modelObject.inception_date, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');
        this.getDocuments(this.modelObject.id);
        this.selectedCoverId = this.modelObject.excess_protect_cover_id;
        this.updateSelectedPremium();
        this.patchValues();

        // Load MTA financials if this is an MTA quote
        if (this.modelObject.type === 3) {
          this.fetchMTAFinancials();
        }
      }

    }



    if (this.selectedIndex >= 3) {
      let inceptionDate: string | number | Date;
      if (this.modelObject.data) {
        this.parentModelObject = this.modelObject.data;
        inceptionDate = this.parentModelObject.attributes.application.inceptionDate;
        this.reference = this.modelObject.reference;
        this.proposerType = this.parentModelObject.attributes.application.proposer.proposer_type;
        if (this.parentModelObject.attributes.premium && this.parentModelObject.attributes.premium.referred) {
          this.isReferred = true;
        }

      } else {
        this.parentModelObject = this.modelObject;
        inceptionDate = this.modelObject.inception_date;
        if (this.apiModelObject) {
          console.log(this.apiModelObject);
          //this.reference = this.apiModelObject.data.quote_ref_number;
        } else {
          this.reference = this.modelObject.reference;
          if (this.modelObject.isReferred) {
            this.isReferred = true;
          }
        }
        this.proposerType = this.modelObject.proposer.proposer_type;
      }

      const maxDate = new Date(inceptionDate).setFullYear(new Date(inceptionDate).getFullYear() + 1);
      const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      this.coverPeriod = formatDate(inceptionDate, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');

      this.getPeliwicaPremium();

      this.formFields.get('broker_admin_fee').setValue(this.modelObject.brokerAdminFee);

    }
    this.handleCoverDropdownState();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  patchValues() {
    this.formFields.patchValue({
      voluntary_excess: this.modelObject.voluntaryExcess,
      commission: 20, // this.modelObject.commission
      broker_admin_fee: this.modelObject.brokerAdminFee,
      discount: (this.modelObject.discount > 0) ? this.modelObject.discount : 0,
      excess_protect_cover_id: this.modelObject.excess_protect_cover_id
    });

    if (this.modelObject.vehicles && this.modelObject.vehicles.length > 0) {
      this.modelObject.vehicles.forEach((res) => {
        // tslint:disable-next-line:no-unused-expression
        res.own;
      });
    }

  }

  /*
 * HELP TEXT POPUP
 */
  helpTextPopup(content, text) {
    this.modalService.open(content, { centered: true });
    this.helptext = text;
  }

  /*
  * Calculate Premium
  */
  calculatePremium() {
    this.calErrors = [];
    this.bindPostData();
    let data;
    let obj = this.modelObject;
    if (this.modelObject.data) {
      obj = this.modelObject.data.attributes.application;
    }
    if (this.apiModelObject && this.apiModelObject.type !== 3) {
      obj.policyId = '';
      obj.effectiveDate = '';
    }

    obj.voluntaryExcess = this.f.voluntary_excess.value;
    data = {
      data: {
        type: 'breakdown/quote',
        attributes: obj
      }

    };

    this.excessProtectService.calculatePremium(data)
      .subscribe(
        (res: any) => {
          if (res.meta) {
            this.hasErrors = false;
            this.isReferred = res.meta.referred;
            if (res.meta.referred) {
              this.calErrors = [];
              const msg = { detail: 'Your quote has referred, clicking save and exit will send your quote to the underwriter for review' };
              this.calErrors.push(msg);
              this.buttonText = 'Save & Refer to Underwriter';
              this.attentionRequiredText = 'This quote needs to be referred, please click ‘Save & Refer to Underwriter’ to proceed.';
            } else {
              this.calErrors = [];
              this.buttonText = 'Save & Exit';
              this.attentionRequiredText = '';
            }

            if (res.meta.vehicle_premiums) {
              this.vehiclePremiumsKey = Object.keys(res.meta.vehicle_premiums)[0];
              this.vehiclePremiumsValue = Number(Object.values(res.meta.vehicle_premiums)[0]);
              this.grossPremium = Number(res.meta.gross);
              this.totalPremIncIpt = Number(res.meta.gross) + Number(res.meta.breakdown_gross);
              // this.gross_premium = Number(Object.values(res.meta.vehicle_premiums)[0]) + Number(res.meta.ipt);
            }
            const brokerAdminFee = (this.modelObject) ? this.modelObject.brokerAdminFee : 0;
            this.formFields.get('broker_admin_fee').setValue(brokerAdminFee);

            if (this.modelObject && this.modelObject.isSendEmail === 1) {
              this.totalAmount = this.grossPremium + Number(brokerAdminFee) + Number(res.meta.breakdown_gross);
            } else {
              this.totalAmount = this.grossPremium + Number(res.meta.breakdown_gross);
            }
            // this.total_amount = this.gross_premium + Number(this.peliwica_fee) + Number(res.meta.breakdown_gross);
            this.premiums = res.meta;
            this.breakdownPremiumsArr = [];
            if (res.meta.breakdown_premiums) {
              if (res.meta.breakdown_premiums instanceof Array) {
                res.meta.breakdown_premiums.forEach((res) => {
                  const breakdown = {
                    registration_number: '',
                    value: 0,
                    is_checked: false
                  };
                  // breakdown[Object.keys(res.meta.breakdown_premiums)[0]] = Number(Object.values(res.meta.breakdown_premiums)[0]);
                  breakdown.registration_number = Object.keys(res.meta.breakdown_premiums)[0];
                  breakdown.value = Number(Object.values(res.meta.breakdown_premiums)[0]);

                  this.breakdownPremiumsArr.push(breakdown);
                });
              } else {
                const breakdown = {
                  registration_number: '',
                  value: 0,
                  is_checked: false
                };
                breakdown.registration_number = Object.keys(res.meta.breakdown_premiums)[0];
                breakdown.value = Number(Object.values(res.meta.breakdown_premiums)[0]);
                this.breakdownPremiumsArr.push(breakdown);

              }


              this.breakdownPremiumsArr.forEach((res) => {
                this.modelObject.vehicles.forEach((res1) => {
                  if (res1.registration_number === res.registration_number) {
                    res.is_checked = res1.breakdown_cover;
                  }
                });
              });
            }
          }
        },
        err => {
          this.hasErrors = true;
          this.calErrors = [];
          if (err.error && err.error.errors) {

            this.calErrors = [];
            const msg = { detail: 'Your quote has referred, clicking save and exit will send your quote to the underwriter for review' };
            this.calErrors.push(msg);
            this.buttonText = 'Save & Refer to Underwriter';
            this.attentionRequiredText = 'This quote needs to be referred, please click ‘Save & Refer to Underwriter’ to proceed.';
          }
          this.premiums = {
            referred: null,
            ipt: 0,
            gross: 0,
            breakdown_ipt: 0,
            breakdown_gross: 0,
            total_amount: 0,
            gross_premium: 0,
            vehicle_premiums: {},
            breakdown_premiums: {},
            vehicle_excesses: {},
            driver_excesses: [],
            compulsory_excess: 0
          };

        },);
  }

  getPeliwicaPremium() {
    this.quoteService.getLiveStockBrokerCommission(this.modelObject.company_id, environment.AMLINE_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            if (this.modelObject.type == 3) {
              this.peliwica_fee = 0;
              this.formFields.get('peliwica_fee').setValue(0);
            } else {
              this.peliwica_fee = response.result.uw_fee;
              this.formFields.get('peliwica_fee').setValue(response.result.uw_fee);
            }
          }
          this.calculatePremium();
        },
        (error) => {
          ;
        }
      );
  }

  /*
  * Bind Breakdown Selection
  */
  onBreakdownSelection(event, vehicle_number) {
    this.modelObject.vehicles.forEach((res) => {
      if (res.registration_number == vehicle_number) {
        res.breakdown_cover = event.value;
      }
    });
    this.calculatePremium();
  }

  /*
  * Commission Restrict to 20
  */
  onCommissionChange(event) {
    if (Number(event.target.value) > 20) {
      this.formFields.get('commission').setValue(20);
    }
    this.calculatePremium();
  }

  /*
  * Broker Commission change modal value
  */
  onBrokerCommissionChange(event) {
    this.modelObject.brokerAdminFee = event.target.value;
    this.calculatePremium();
  }

  /*
  * Discount Restrict to 10
  */
  onDiscountChange(event) {
    if (Number(event.target.value) > 10) {
      this.formFields.get('discount').setValue(10);
    }
    if (Number(event.target.value) < 0) {
      this.formFields.get('discount').setValue(0);
    }
    this.calculatePremium();
  }

  /*
  * Bind Owner Name
  */
  onOwnerNameChange(event, vehicle_id) {
    this.modelObject.vehicles.forEach((res) => {
      if (res.id == vehicle_id) {
        res.owner_name = event.target.value;
      }
    });
  }

  onReferReasonChange(value: string): void {
    this.formFields.get('refer_reason').disable();
    if (value !== '') {
      this.formFields.get('refer_reason').enable();
    }
  }

  setReferAndExit(val: boolean): void {
    this.referAndExit = val;
  }

  /*
  * Save Quote Details
  */
  onSubmit(content, referral) {
    this.submitted = true;
    this.formFields.get('refer_reason').disable();

    if (!this.formFields.valid) {
      return false;
    }

    if (this.hasErrors) {
      return false;
    }

    if (this.modelObject.type === 2) {
      this.modelObject.policyId = null;
      this.modelObject.effectiveDate = null;
    }

    if (this.isReferred) {
      this.modalService.open(referral, { centered: true });
    } else {
      this.saveQuote(content);
    }
  }

  bindPostData() {
    const formData = this.formFields.value;
    this.modelObject.voluntaryExcess = formData.voluntary_excess;
    this.modelObject.commission = 20; // formData.commission;
    this.modelObject.discount = (formData.discount > 0) ? formData.discount : 0;
    this.modelObject.peliwica_fee = formData.peliwica_fee;
  }

  saveQuote(content) {
    let obj;
    if (this.modelObject.amlin_data) {
      obj = this.modelObject.amlin_data.data.attributes.application;
    } else {
      obj = this.modelObject;
    }

    const formData = this.formFields.value;
    obj.voluntary_excess = formData.voluntary_excess;
    obj.commission = formData.commission;
    obj.broker_admin_fee = formData.broker_admin_fee;
    obj.discount = formData.discount;
    obj.peliwica_fee = formData.peliwica_fee;


    let referReason = '';
    if (this.isAdmin || this.isStaff) {
      if (this.referAndExit) {
        this.isReferred = true;
        referReason = this.formFields.get('refer_reason').value;
        this.formFields.get('refer_reason').disable();
        if (referReason === '') {
          this.formFields.get('refer_reason').enable();
          return;
        }
      }
    }
    let proposer_type = '';
    if (this.modelObject.proposer.proposer_type == 1) {
      proposer_type = 'individual';
    }
    else if (this.modelObject.proposer.proposer_type == 2) {
      proposer_type = 'joint';
    }
    else {
      proposer_type = 'company';
    }
    let micro_enterprise = false;
    if (this.modelObject.proposer.micro_enterprise == 1) {
      micro_enterprise = true;
    }
    let data = {
      "quote_data": {
        "type": this.modelObject.type,
        "attributes": this.modelObject.vehicles,
        "vehicle_details": this.modelObject.vehicles,
        // "id": (this.route.snapshot.params.id) ? this.route.snapshot.params.id : this.modelObj.id
        "id": this.modelObject.id,
        "quote_meta_id": this.modelObject.quoteMetaId,
        "broker_id": this.modelObject.broker_id,
        "company_id": this.modelObject.company_id,
        "sequence_number": this.modelObject.sequenceNumber,
        "policy_start_date": this.modelObject.inception_date,
        "excess_protect_cover_id": this.modelObject.excess_protect_cover_id,
        "policy_ref_number": this.modelObject.policyRefNumber,
        "effective_date": this.quote_type == 3 ? this.modelObject.effectiveDate : null,
        "policy_holder": {
          "title": this.modelObject.proposer.title,
          "first_name": this.modelObject.proposer.first_name,
          "last_name": this.modelObject.proposer.last_name,
          "email": this.modelObject.proposer.email,
          "phone": this.modelObject.proposer.phone,
          "mobile": this.modelObject.proposer.mobile ? this.modelObject.proposer.mobile : '',
          "dob": this.modelObject.proposer.dob,
          "company_name": this.modelObject.proposer.company_name ? this.modelObject.proposer.company_name : '',
          "trading_name": this.modelObject.proposer.trading_name ? this.modelObject.proposer.trading_name : '',
          "proposer_type": proposer_type,
          "year": this.modelObject.proposer.year,
          "micro_enterprise": micro_enterprise,
        },
        "address": {
          "address1": this.modelObject.proposer.address.line1,
          "address2": this.modelObject.proposer.address.line2,
          "address3": this.modelObject.proposer.address.line3,
          "address4": "",
          "address5": "",
          "city": this.modelObject.proposer.address.county,
          "country": "UK",
          "postcode": this.modelObject.proposer.address.postcode,
        },
        "sms": this.modelObject.proposer.sms,
        "post": this.modelObject.proposer.post,
        "is_phone": this.modelObject.proposer.is_phone,
        "is_email": this.modelObject.proposer.is_email,
        // 'send_email': this.apiModelObject?.excess_protect_cover_id ? 0 : 1,
        'send_email': 1,
      },
      meta: {
        refer: this.isReferred,
        refer_reason: referReason,
      },
    };


    this.excessProtectService.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.modalService.open(content, { centered: true });
            this.helptext = 'Data Saved.';
            this.modelObjectUpdated.emit(this.modelObject);
            this.router.navigateByUrl('/excess-protect/quote-details/' + res.result.quote_data.quote_versions[0].id);
          } else {
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

          this.modalService.dismissAll();
        });
  }
  onCoverChange() {
    this.selectedCoverId = this.formFields.get('excess_protect_cover_id').value;
    this.updateSelectedPremium();
    // For MTA (type 3), fetch MTA financials from backend
    if (this.modelObject.type === 3 && this.selectedCoverId) {
      this.fetchMTAFinancials();
    }
  }

  updateSelectedPremium() {
    const selected = this.excessProtectOptions.result.find(
      (item: any) => item.id === this.selectedCoverId
    );

    this.selectedPremium = selected || null;

    if (selected) {
      this.modelObject.excess_protect_cover_id = selected.id;
    }
  }
  private mapApiToExcessProtect(api: any): ExcessProtect {
    const model = new ExcessProtect();
    if (!api) {
      return model;
    }
    model.id = api.id;
    model.type = api.type;
    model.broker_id = api.broker_id;
    model.company_id = api.company_id;
    model.sequenceNumber = api.sequence_number;
    model.policyRefNumber = api.policy_ref_number;
    model.quoteMetaId = api.quote_meta_id;
    model.excess_protect_cover_id = api.excess_protect_cover_id;

    model.inception_date = api.policy_start_date;
    model.cover_to = api.policy_end_date;
    model.effectiveDate = api.effective_date;

    // proposer
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.first_name = api.policy_holder.first_name;
    model.proposer.last_name = api.policy_holder.last_name;
    model.proposer.title = api.policy_holder.title;
    model.proposer.dob = api.policy_holder.dob;
    model.proposer.email = api.policy_holder.email;
    model.proposer.phone = api.policy_holder.phone;
    model.proposer.is_phone = api.policy_holder.is_phone;
    model.proposer.sms = api.policy_holder.sms;
    model.proposer.post = api.policy_holder.post;
    model.proposer.is_email = api.policy_holder.is_email;
    model.proposer.proposer_type = api.policy_holder.proposer_type;
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.company_name = api.policy_holder.company_name;
    model.proposer.trading_name = api.policy_holder.trading_name;
    model.proposer.year = api.policy_holder.year_of_establishment;
    model.proposer.address.line1 = api.policy_holder.address.address1;
    model.proposer.address.line2 = api.policy_holder.address.address2;
    model.proposer.address.line3 = api.policy_holder.address.address3;
    model.proposer.address.line4 = api.policy_holder.address.address4;
    model.proposer.address.county = api.policy_holder.address.city;
    model.proposer.address.postcode = api.policy_holder.address.postcode;
    model.proposer.address.country = api.policy_holder.address.country;

    model.vehicles = api.vehicles ?? [];

    // financial details
    if (api.financial_details) {
      model.brokerAdminFee = api.financial_details.broker_admin_fee;
      model.brokerComission = api.financial_details.broker_commission;
    }

    return model;
  }

  getDocuments(id) {
    let type = 1;
    this.quoteService.getQuoteDocuments(id, type)
      .subscribe(
        (response: any) => {
          if (response.success) {
            const generatedDocs = response.result.filter(doc => doc.is_static == 0);
            const uniqueDocuments = this.getLatestUniqueDocuments(response.result);
            //const staticDocs = response.result.filter(doc => doc.is_static == 1);
            const staticDocs = response.result;
            //this.rowDataPeliwica = generatedDocs;
            this.documents = uniqueDocuments;
          }
        },
        (error) => {
          ;
        }
      );
  }
  getLatestUniqueDocuments(documents: any[]): any[] {
    // Group documents by a unique identifier (adjust based on your data structure)
    // Assuming documents have an 'id' or 'title' field to identify duplicates
    const documentMap = new Map<string, any>();

    documents.forEach(doc => {
      const key = doc.title || doc.id; // Use title or id as the unique key
      const existing = documentMap.get(key);

      // Keep the document with the latest date/timestamp
      // Adjust the date field name based on your data structure (e.g., 'created_at', 'updated_at', 'timestamp')
      if (!existing || new Date(doc.created_at) > new Date(existing.created_at)) {
        documentMap.set(key, doc);
      }
    });

    return Array.from(documentMap.values());
  }
  downloadDocument(actionType: string, document: any) {
    if (actionType === 'download') {
      this.quoteService.downloadDocs(document);
    }
  }
  getDisplayTitle(title: string): string {
    if (!title) {
      return '';
    }

    const t = title.toUpperCase();

    if (t.includes('QUOTE')) {
      return 'Quote Schedule';
    }

    if (t.includes('POLICY')) {
      return 'Policy Wording';
    }

    if (t.includes('IPID')) {
      return 'IPID';
    }

    return title; // fallback
  }
  showMTACalculation: boolean = false;
  isLoadingMTA: boolean = false;
  mtaFinancials: any = null;

  /**
   * Fetch MTA Financials from Backend
   * This method calls the backend API to calculate MTA adjustments
   */
  fetchMTAFinancials() {
    if (!this.modelObject.id || !this.selectedCoverId) {
      console.warn('Missing required data for MTA calculation');
      this.showMTACalculation = false;
      return;
    }

    this.isLoadingMTA = true;
    this.showMTACalculation = false;

    // Prepare request payload
    const mtaRequest = {
      quote_id: this.modelObject.id,
      quote_meta_id: this.modelObject.quoteMetaId,
      previous_policy_id: this.apiModelObject?.id, // ID of the policy being modified
      excess_protect_cover_id: this.selectedCoverId,
      effective_date: this.modelObject.effectiveDate || new Date().toISOString().split('T')[0],
      type: this.quote_type
    };

    console.log('Fetching MTA Financials:', mtaRequest);

    // Call backend service
    this.excessProtectService.calculateMTAFinancials(mtaRequest)
      .subscribe(
        (response: any) => {
          this.isLoadingMTA = false;

          if (response.success && response.mta_financials) {
            this.mtaFinancials = response.mta_financials;
            this.showMTACalculation = true;

            console.log('MTA Financials received:', this.mtaFinancials);
            this.mtaFinancialsUpdated.emit(this.mtaFinancials);
            // Show success message
            // this._snackBar.open('MTA adjustment calculated successfully', 'Close', {
            //   duration: 3000,
            //   panelClass: 'success-snackbar'
            // });
            console.log('MTA adjustment calculated successfully');
          } else {
            console.warn('No MTA financials in response');
            this.showMTACalculation = false;

            this._snackBar.open('Unable to calculate MTA adjustment', 'Close', {
              duration: 3000,
              panelClass: 'warning-snackbar'
            });
          }
        },
        (error) => {
          this.isLoadingMTA = false;
          this.showMTACalculation = false;

          console.error('Error fetching MTA financials:', error);

          this._snackBar.open('Error calculating MTA adjustment. Please try again.', 'Close', {
            duration: 5000,
            panelClass: 'error-snackbar'
          });
        }
      );
  }
  handleCoverDropdownState() {
    const control = this.formFields.get('excess_protect_cover_id');
control?.disable();
    // if (this.quote_type == 3 || this.modelObject.type == 3) {
    //   control?.disable();
    // } else {
    //   control?.enable();
    // }
  }
    goBack() {
    this.back.emit();
  }
}
